var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "divBox" },
    [
      _c(
        "el-card",
        { attrs: { shadow: "never" } },
        [
          _c(
            "div",
            { staticClass: "toolbar" },
            [
              _c("el-input", {
                attrs: {
                  clearable: "",
                  placeholder: "优惠券名称",
                  size: "small",
                },
                nativeOn: {
                  keyup: function ($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                    ) {
                      return null
                    }
                    return _vm.load($event)
                  },
                },
                model: {
                  value: _vm.query.keywords,
                  callback: function ($$v) {
                    _vm.$set(
                      _vm.query,
                      "keywords",
                      typeof $$v === "string" ? $$v.trim() : $$v
                    )
                  },
                  expression: "query.keywords",
                },
              }),
              _c(
                "el-select",
                {
                  attrs: {
                    clearable: "",
                    placeholder: "优惠类型",
                    size: "small",
                  },
                  model: {
                    value: _vm.query.type,
                    callback: function ($$v) {
                      _vm.$set(_vm.query, "type", $$v)
                    },
                    expression: "query.type",
                  },
                },
                [
                  _c("el-option", { attrs: { label: "满减", value: 1 } }),
                  _c("el-option", { attrs: { label: "折扣", value: 2 } }),
                ],
                1
              ),
              _c(
                "el-button",
                {
                  attrs: {
                    type: "primary",
                    size: "small",
                    icon: "el-icon-search",
                  },
                  on: { click: _vm.load },
                },
                [_vm._v("查询")]
              ),
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "hasPermi",
                      rawName: "v-hasPermi",
                      value: ["distribution:store:coupon:save"],
                      expression: "['distribution:store:coupon:save']",
                    },
                  ],
                  attrs: {
                    type: "primary",
                    size: "small",
                    icon: "el-icon-plus",
                  },
                  on: {
                    click: function ($event) {
                      return _vm.open()
                    },
                  },
                },
                [_vm._v("新增优惠券")]
              ),
            ],
            1
          ),
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              attrs: { data: _vm.rows, border: "", size: "small" },
            },
            [
              _c("el-table-column", {
                attrs: { label: "序号", width: "60", align: "center" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [_vm._v(_vm._s(_vm.$pageIndex(scope)))]
                    },
                  },
                ]),
              }),
              false
                ? _c("el-table-column", {
                    attrs: { prop: "id", label: "ID", width: "75" },
                  })
                : _vm._e(),
              _c("el-table-column", {
                attrs: {
                  prop: "name",
                  label: "优惠券名称",
                  "min-width": "180",
                },
              }),
              _c("el-table-column", {
                attrs: { label: "优惠内容", "min-width": "130" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(
                          _vm._s(
                            scope.row.type === 1
                              ? "减 ¥" + scope.row.discountPrice
                              : scope.row.discountRate + " 折"
                          )
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { prop: "useMinPrice", label: "使用门槛", width: "110" },
              }),
              _c("el-table-column", {
                attrs: { label: "剩余/总量", width: "120" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(
                          _vm._s(
                            scope.row.total < 0
                              ? "不限量"
                              : scope.row.remainNum + "/" + scope.row.total
                          )
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "有效期", "min-width": "190" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(
                          _vm._s(
                            scope.row.validType === 2
                              ? "领取后 " + scope.row.validDays + " 天"
                              : (scope.row.startTime || "-") +
                                  " 至 " +
                                  (scope.row.endTime || "-")
                          )
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "状态", width: "100" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("el-switch", {
                          attrs: { "active-value": 1, "inactive-value": 0 },
                          on: {
                            change: function ($event) {
                              return _vm.toggle(scope.row)
                            },
                          },
                          model: {
                            value: scope.row.status,
                            callback: function ($$v) {
                              _vm.$set(scope.row, "status", $$v)
                            },
                            expression: "scope.row.status",
                          },
                        }),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "操作", width: "150", fixed: "right" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-button",
                          {
                            attrs: { type: "text" },
                            on: {
                              click: function ($event) {
                                return _vm.open(scope.row)
                              },
                            },
                          },
                          [_vm._v("编辑")]
                        ),
                        _c(
                          "el-button",
                          {
                            staticClass: "danger",
                            attrs: { type: "text" },
                            on: {
                              click: function ($event) {
                                return _vm.remove(scope.row)
                              },
                            },
                          },
                          [_vm._v("删除")]
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _c("el-pagination", {
            attrs: {
              background: "",
              "current-page": _vm.query.page,
              "page-size": _vm.query.limit,
              total: _vm.total,
              layout: "total, prev, pager, next",
            },
            on: { "current-change": _vm.pageChange },
          }),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.form.id ? "编辑优惠券" : "新增优惠券",
            visible: _vm.visible,
            width: "650px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.visible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "form",
              attrs: {
                model: _vm.form,
                rules: _vm.rules,
                "label-width": "105px",
                size: "small",
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "优惠券名称", prop: "name" } },
                [
                  _c("el-input", {
                    attrs: { maxlength: "60" },
                    model: {
                      value: _vm.form.name,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.form,
                          "name",
                          typeof $$v === "string" ? $$v.trim() : $$v
                        )
                      },
                      expression: "form.name",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-row",
                { attrs: { gutter: 20 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "优惠类型" } },
                        [
                          _c(
                            "el-radio-group",
                            {
                              model: {
                                value: _vm.form.type,
                                callback: function ($$v) {
                                  _vm.$set(_vm.form, "type", $$v)
                                },
                                expression: "form.type",
                              },
                            },
                            [
                              _c("el-radio", { attrs: { label: 1 } }, [
                                _vm._v("满减"),
                              ]),
                              _c("el-radio", { attrs: { label: 2 } }, [
                                _vm._v("折扣"),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.form.type === 1 ? "优惠金额" : "折扣率",
                          },
                        },
                        [
                          _vm.form.type === 1
                            ? _c("el-input-number", {
                                attrs: { min: 0.01, precision: 2 },
                                model: {
                                  value: _vm.form.discountPrice,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "discountPrice", $$v)
                                  },
                                  expression: "form.discountPrice",
                                },
                              })
                            : _c("el-input-number", {
                                attrs: { min: 0.1, max: 9.9, precision: 1 },
                                model: {
                                  value: _vm.form.discountRate,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "discountRate", $$v)
                                  },
                                  expression: "form.discountRate",
                                },
                              }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-row",
                { attrs: { gutter: 20 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "使用门槛" } },
                        [
                          _c("el-input-number", {
                            attrs: { min: 0, precision: 2 },
                            model: {
                              value: _vm.form.useMinPrice,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "useMinPrice", $$v)
                              },
                              expression: "form.useMinPrice",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "发放总量" } },
                        [
                          _c("el-input-number", {
                            attrs: { min: -1 },
                            model: {
                              value: _vm.form.total,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "total", $$v)
                              },
                              expression: "form.total",
                            },
                          }),
                          _c("span", { staticClass: "hint" }, [
                            _vm._v("-1 表示不限量"),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "每人限领" } },
                [
                  _c("el-input-number", {
                    attrs: { min: 0 },
                    model: {
                      value: _vm.form.limitPerUser,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "limitPerUser", $$v)
                      },
                      expression: "form.limitPerUser",
                    },
                  }),
                  _c("span", { staticClass: "hint" }, [_vm._v("0 表示不限")]),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "有效期类型" } },
                [
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value: _vm.form.validType,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "validType", $$v)
                        },
                        expression: "form.validType",
                      },
                    },
                    [
                      _c("el-radio", { attrs: { label: 1 } }, [
                        _vm._v("固定日期"),
                      ]),
                      _c("el-radio", { attrs: { label: 2 } }, [
                        _vm._v("领取后天数"),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm.form.validType === 1
                ? _c(
                    "el-form-item",
                    { attrs: { label: "有效期" } },
                    [
                      _c("el-date-picker", {
                        attrs: {
                          type: "datetimerange",
                          "start-placeholder": "开始日期",
                          "end-placeholder": "结束日期",
                          "value-format": "yyyy-MM-dd HH:mm:ss",
                        },
                        model: {
                          value: _vm.dateRange,
                          callback: function ($$v) {
                            _vm.dateRange = $$v
                          },
                          expression: "dateRange",
                        },
                      }),
                    ],
                    1
                  )
                : _c(
                    "el-form-item",
                    { attrs: { label: "有效天数" } },
                    [
                      _c("el-input-number", {
                        attrs: { min: 1 },
                        model: {
                          value: _vm.form.validDays,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "validDays", $$v)
                          },
                          expression: "form.validDays",
                        },
                      }),
                    ],
                    1
                  ),
              _c(
                "el-form-item",
                { attrs: { label: "立即开启" } },
                [
                  _c("el-switch", {
                    attrs: { "active-value": 1, "inactive-value": 0 },
                    model: {
                      value: _vm.form.status,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "status", $$v)
                      },
                      expression: "form.status",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "span",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.visible = false
                    },
                  },
                },
                [_vm._v("取消")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", loading: _vm.saving },
                  on: { click: _vm.submit },
                },
                [_vm._v("保存")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }